import { createRoutableExtension } from '@backstage/core-plugin-api';
import { catalogPlugin } from '@backstage/plugin-catalog';

/**
 * Preserve the catalog plugin's root route contract while rendering Make's
 * custom catalog composition.
 *
 * `FlatRoutes` discovers route refs from the element passed directly to the
 * route. Exporting the page through the catalog plugin keeps integrations such
 * as org links and scaffolder bindings working exactly as they do with
 * Backstage's default `CatalogIndexPage`.
 */
export const MakeCatalogIndexPage = catalogPlugin.provide(
  createRoutableExtension({
    name: 'MakeCatalogIndexPage',
    component: () => import('./CatalogPage').then(module => module.CatalogPage),
    mountPoint: catalogPlugin.routes.catalogIndex,
  }),
);
